<template>
  <div class="summary-checklist-content" id="identidade-verbal-resumindo-checklist" data-search-anchor>
    <div class="summary-checklist-wrapper">
      <h1 class="summary-checklist-title">{{ summaryChecklistTitle }}</h1>
      <p class="summary-checklist-text">{{ summaryChecklistText }}</p> 
    </div>
    <div class="summary-checklist-description-wrapper">     
      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription1 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription2 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription3 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription4 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription5 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription6 }}</p>
      </div>

      <div class="icon-wrapper">
        <IconCheck />
        <p class="summary-checklist-description-icon">{{ summaryChecklistDescription7 }}</p>
      </div>
    </div>
    <div
      class="summary-checklist-card-item"
      :style="{ backgroundImage: `url(${summaryChecklistImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import SummaryPageMixin from '@/mixins/summary-page-mixin'
import { SummaryPageStore } from '@/store/verbal-identity-page/summary-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class SummaryChecklistSection extends Mixins(SummaryPageMixin) {
  summaryPageStore: PageStoreContract = getModule(SummaryPageStore, this.$store)

  get summaryChecklistTitle(): string {
    return this.getElementTitle(2, 0)
  }

  get summaryChecklistText(): string {
    return this.getElementText(2, 0)
  }

  get summaryChecklistDescription(): string {
    return this.getElementText(2, 1)
  }

  get summaryChecklistDescription1(): string {
    return this.getElementText(2, 2)
  }

  get summaryChecklistDescription2(): string {
    return this.getElementText(2, 3)
  }

  get summaryChecklistDescription3(): string {
    return this.getElementText(2, 4)
  }

  get summaryChecklistDescription4(): string {
    return this.getElementText(2, 5)
  }

  get summaryChecklistDescription5(): string {
    return this.getElementText(2, 6)
  }

  get summaryChecklistDescription6(): string {
    return this.getElementText(2, 7)
  }

   get summaryChecklistDescription7(): string {
    return this.getElementText(2, 8)
  }

  get summaryChecklistImageSrc(): string {
    return this.getElementMedia(2, 9)
  }

  async getSummaryChecklistPage(): Promise<void> {
    await this.summaryPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.summaryPageStore.isLoading) {
      await this.getSummaryChecklistPage()
    }
  }
}
</script>

<style lang="scss">
.summary-checklist-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.summary-checklist-wrapper {
  display: block;
  align-items: center;  
  padding-top: 85px;
  padding-bottom: 50px;
}

.summary-checklist-title {  
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  margin-bottom: 0px;
}

.summary-checklist-text {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-top: 0px;

  color: #000000;
}

.summary-checklist-description-wrapper {  
  position: relative;  

  display: flex;
  flex-direction: column;
    
}

.summary-checklist-description-icon,
.summary-checklist-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;  
  width: 814px;
  white-space: pre;
}

.summary-checklist-description {  
  padding-left: 0;
  width: 430px;
}

.summary-checklist-card-item {
  position: relative;
  max-width: 1032px;
  width: 100%;
  height: 580px;
  border-radius: 12px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin-top: 73.94px;
}

.icon-wrapper{
  padding-left: 0 !important; 
  padding-bottom: 0 !important;
}
</style>
